export const appPowerPoint = "OAa";
export default {appPowerPoint};